import { atom } from 'jotai';

export type ReferralInviteSource =
  | 'dashboard_card'
  | 'nav_cta'
  | 'offline_jp_modal'
  | 'hire_confirmation_modal'
  | 'new_company_home';

export type ReferralInviteModalState = {
  isOpen: boolean;
  source: ReferralInviteSource;
};

export const referralInviteModalAtom = atom<ReferralInviteModalState>({
  isOpen: false,
  source: 'dashboard_card',
});
